module.exports = __webpack_public_path__ + "img/analyzing-photo-desktop-fr.87cf3dfd.jpg";